module.exports = __webpack_public_path__ + "img/footer__logo.15b69dc2.svg";